export default {
  common: {
    pleaseEnterSearchKeywords: "Bitte geben Sie Suchbegriffe ein"
  },
  outputProjectList: {
    dateofRegistration: "Registrierungsdatum",
    updateDate: "Aktualisierungszeitpunkt",
    projectName: "Projektname",
    dateofAudit: "Auditdatum (Jahr-Monat)",
    customerName: "Kundenname",
    customerEmail: "E-Mail-Adresse des Kunden",
    address: "Adresse",
    zone: "Gebiet",
    city: "Stadt",
    submiter: "Einreicher",
    projectStatus: "Projektstatus",
    estimateEcmQutedAmount: "Geschätzter ECM-Angebotsbetrag (USD)",
    expectedOrder: "Erwarteter Auftrag (Monat/Jahr)",
    actualEcmQutedAmount: "Tatsächlicher ECM-Angebotsbetrag (USD)",
    actualOrder: "Tatsächlicher Auftrag (Monat/Jahr)",
    winProbability: "Abschlusswahrscheinlichkeit",
    statusRemarks: "Projektanmerkungen",
    lastUpdateDate: "Datum der letzten Aktualisierung"
  },
  outputAccountList: {
    activate: "Aktivieren",
    registerDate: "Registrierungsdatum",
    lastLoginDate: "Datum der letzten Anmeldung"
  },
  nomenclature: {
    row0_1: "Begriff",
    row0_2: "Definition",
    row1_1: "AC",
    row1_2: "Luftgekühlt.",
    row2_1: "AHRI",
    row2_2: "Air-Conditioning, Heating, and Refrigeration Institute — der US-Branchenverband, der die für e-CAT-Auswahlen verwendeten Leistungsangaben von Flüssigkeitskühlern zertifiziert.",
    row3_1: "Luftgekühlter Flüssigkeitskühler",
    row3_2: "Ein Flüssigkeitskühler, der Wärme mithilfe von Verflüssigerventilatoren direkt an die Umgebungsluft abgibt und keine Kühltürme oder Kühlwasserpumpen für den Verflüssiger benötigt.",
    row4_1: "Kühlgrenzabstand",
    row4_2:
      "Die Temperaturdifferenz zwischen der Wasseraustrittstemperatur des Kühlturms und der Feuchtkugeltemperatur der eintretenden Luft; der Standardwert in iECM beträgt 3 °C. Dies ist ein wesentlicher Parameter für die Modellierung des Verflüssigerkühlwassers.",
    row5_1: "ASIA",
    row5_2: "Portfolio der Region Asien. Das Fertigungsportfolio für Carrier-Flüssigkeitskühler, die hauptsächlich in Asien angeboten werden.",
    row6_1: "Ausgangsbasis",
    row6_2: "Das aktuelle Flüssigkeitskühlersystem, das als Vergleichsmaßstab dient.",
    row7_1: "Gebäudenutzungsart",
    row7_2: "Die bei der Projekteinrichtung ausgewählte Gebäudetypklassifizierung, beispielsweise Büro, Hotel, Krankenhaus oder Sonstige; sie kann Standardannahmen beeinflussen.",
    row8_1: "CAPEX",
    row8_2: "Investitionsausgaben; die anfänglichen Investitionskosten des Modernisierungsprojekts.",
    row9_1: "CO₂-Emissionsfaktor des Stroms",
    row9_2: "Die je verbrauchter Stromeinheit ausgestoßene Masse an CO₂-Äquivalent; der iECM-Standardwert beträgt 0,707 kgCO₂e/kWh, wobei der Wert je nach Region und Strommix variiert.",
    row10_1: "Flüssigkeitskühler mit Turboverdichter",
    row10_2: "Ein Flüssigkeitskühlertyp mit Turboverdichter, der häufig in großen gewerblichen und industriellen Anwendungen eingesetzt wird; in iECM wird er als „WC–Centri“ bezeichnet.",
    row11_1: "Kaltwasser",
    row11_2: "Vom Flüssigkeitskühler abgekühltes Wasser, das zur Raumkühlung durch die Lüftungsanlage des Gebäudes zirkuliert.",
    row12_1: "CHW",
    row12_2: "Kaltwasser.",
    row13_1: "CHWP",
    row13_2: "Kaltwasserpumpe.",
    row14_1: "Gruppe",
    row14_2: "Eine Gruppe von Monaten mit ähnlichen Betriebs- oder Witterungsbedingungen, die in der Simulation verwendet wird.",
    row15_1: "Komfortkühlung",
    row15_2: "Kühlung zur Gewährleistung des thermischen Komforts der Nutzer in Gebäuden wie Büros und Hotels; sie unterscheidet sich von der Prozesskühlung.",
    row16_1: "Gemeinsame Sammelleitung",
    row16_2:
      "Eine Verrohrung des Verflüssigerkühlwassers, bei der alle Flüssigkeitskühler eine gemeinsame Vorlauf- und Rücklaufsammelleitung nutzen, sodass jeder Kühlturm jeden Flüssigkeitskühler versorgen kann.",
    row17_1: "Kühlwasser des Verflüssigers",
    row17_2: "Wasser, das zwischen dem Verflüssiger des Flüssigkeitskühlers und dem Kühlturm zirkuliert, um Wärme aus dem Kältekreislauf abzuführen.",
    row18_1: "COP",
    row18_2: "Leistungszahl.",
    row19_1: "CT",
    row19_2: "Kühlturm.",
    row20_1: "CWP",
    row20_2: "Kühlwasserpumpe des Verflüssigers.",
    row21_1: "CWS",
    row21_2: "Kühlwasservorlauf zum Verflüssiger.",
    row22_1: "DB",
    row22_2: "Schaltschrank.",
    row23_1: "Alterungsfaktor",
    row23_2:
      "Der jährliche prozentuale Rückgang des Wirkungsgrads eines Flüssigkeitskühlers infolge von Alterung, Verschmutzung und Verschleiß; typische Annahmen sind 0,25 % bei gutem, 0,50 % bei durchschnittlichem, 0,75 % bei unterdurchschnittlichem und 1,00 % bei schlechtem Zustand.",
    row24_1: "Digitaler e-CAT",
    row24_2: "Ein physikbasiertes und datengestütztes Modellierungswerkzeug zur Prognose des Leistungsverhaltens von Flüssigkeitskühlern.",
    row25_1: "Kalkulationszinssatz",
    row25_2: "Der Zinssatz zur Berechnung des Barwerts zukünftiger Zahlungsströme in der Kapitalwertanalyse (NPV); der iECM-Standardwert beträgt 3 %.",
    row26_1: "Trockenkugeltemperatur",
    row26_2:
      "Die mit einem herkömmlichen Thermometer gemessene Umgebungslufttemperatur, unbeeinflusst von Feuchtigkeit; sie wird in iECM-Wetterprofilen zur Modellierung luftgekühlter Flüssigkeitskühler und für Gruppeneinstellungen verwendet.",
    row27_1: "e-CAT-Bibliothek",
    row27_2: "Die offizielle Carrier-e-CAT-Datenbank für Flüssigkeitskühler, die allen Benutzern zur Verfügung steht.",
    row28_1: "EA",
    row28_2: "Energieaudit.",
    row29_1: "EA-Bericht",
    row29_2: "Energieaudit-Bericht — der am Ende des Schritts Vorschau der Ausgangsbasis erstellte Bericht, der das aktuelle Systemleistungsverhalten und Verbesserungsmöglichkeiten dokumentiert.",
    row30_1: "e-CAT",
    row30_2: "Elektronischer Katalog und Flüssigkeitskühler-Auswahlsoftware von Carrier.",
    row31_1: "ECM",
    row31_2: "Energieeinsparmaßnahme; eine vorgeschlagene Maßnahme zur Wirkungsgradsteigerung.",
    row32_1: "ECM-Bericht",
    row32_2: "Bericht über Energieeinsparmaßnahmen — das Angebotsdokument mit der empfohlenen Lösung, den Energieeinsparungen, der Wirtschaftlichkeitsanalyse und der Wirtschaftlichkeitsbegründung.",
    row33_1: "EER",
    row33_2: "Kälteleistungszahl (Energy Efficiency Ratio)",
    row34_1: "EMEA",
    row34_2: "Europa, Naher Osten und Afrika. Das Fertigungsportfolio für Carrier-Flüssigkeitskühler, die in Europa, im Nahen Osten und in Afrika angeboten werden.",
    row35_1: "Preissteigerungsrate",
    row35_2: "Der angenommene jährliche prozentuale Anstieg von Betriebskosten wie Energie-, Wartungs-, Reparatur- und sonstigen Kosten; der iECM-Standardwert beträgt 2 % pro Jahr.",
    row36_1: "Geschätzte e-CAT-Leistungsdaten",
    row36_2: "Vom digitalen e-CAT-Algorithmus geschätzte Leistungsdaten, wenn keine Standard-e-CAT-Daten verfügbar sind.",
    row37_1: "Wechselkurs",
    row37_2: "Devisenwechselkurs.",
    row38_1: "Hz",
    row38_2: "Hertz — die Einheit der Frequenz; sie wird in iECM zur Festlegung der Betriebsgrenzen von Frequenzumrichtern für Pumpen und Kühlturmventilatoren verwendet.",
    row39_1: "iECM",
    row39_2: "Intelligente Energieeinsparmaßnahme; Carriers Werkzeug für Energieaudits und Modernisierungsanalysen zur Optimierung von Kältezentralen.",
    row40_1: "Förderungen und Zuschüsse",
    row40_2: "Staatliche oder vom Energieversorger gewährte finanzielle Förderungen, die für bis zu 19 Jahre jahresweise in der Kapitalwertberechnung (NPV) berücksichtigt werden.",
    row41_1: "kgCO₂e",
    row41_2: "Kilogramm CO₂-Äquivalent — die Einheit zur Angabe der mit dem Stromverbrauch verbundenen Treibhausgasemissionen.",
    row42_1: "kW",
    row42_2: "Kilowatt — eine Einheit der elektrischen Leistung, entsprechend 1.000 Watt.",
    row43_1: "kWc",
    row43_2: "Kilowatt Kälteleistung — die in Kilowatt gemessene Kälteleistungsabgabe eines Flüssigkeitskühlers oder einer Anlage.",
    row44_1: "kWe",
    row44_2: "Elektrische Leistungsaufnahme in Kilowatt — die von einem Flüssigkeitskühler oder einer Anlagenkomponente aufgenommene elektrische Leistung.",
    row45_1: "kWh",
    row45_2: "Kilowattstunde — eine Einheit des Energieverbrauchs, entsprechend einer über 1 Stunde aufrechterhaltenen Leistung von 1 kW.",
    row46_1: "kWh/RTh",
    row46_2: "Kilowattstunden je Kältetonnenstunde; eine Kennzahl für den Anlagenwirkungsgrad.",
    row47_1: "Produktionsregion/-herkunft",
    row47_2:
      "Das regionale Carrier-Fertigungsportfolio zur Festlegung der unterstützten Flüssigkeitskühler-Modellbibliothek (ASIA, EMEA oder NAO). Dieselbe Flüssigkeitskühlerbaureihe kann in mehreren Regionen verfügbar sein.",
    row48_1: "Mehrpunkteingabe",
    row48_2:
      "Eine iECM-Dateneingabefunktion, die den Wert des aktuellen Monats in alle nachfolgenden Monate kopiert und so wiederholte Eingaben beschleunigt, ohne zuvor eingegebene Werte zu überschreiben.",
    row49_1: "NAO",
    row49_2: "North America Operations. Das Fertigungsportfolio für Carrier-Flüssigkeitskühler, die über North America Operations angeboten werden.",
    row50_1: "NPV",
    row50_2: "Kapitalwert; der Barwert zukünftiger projektbezogener Zahlungsströme.",
    row51_1: "Niedertarifzeit",
    row51_2: "Gesamte monatliche Mitteltemperatur. Sie repräsentiert den gemittelten Tagesabschnitt und wird zur Gewichtung der Zuordnung zu nächtlichen Niedertarifzeiten verwendet.",
    row52_1: "Betriebszeitraum",
    row52_2:
      "Die bei der Modellierung der monatlichen Ausgangsbasis verwendete Klassifizierung nach Tagesarten – Wochentag, Wochenende oder gesamter Zeitraum – zur Abbildung unterschiedlicher Nutzungsmuster.",
    row53_1: "Am Standort betriebener Flüssigkeitskühler",
    row53_2:
      "Ein am Standort vorhandener Flüssigkeitskühler, der zur Abbildung des hauptsächlich betriebenen Flüssigkeitskühlers während eines bestimmten Lastzeitraums, beispielsweise Hoch- oder Niedertarifzeit, ausgewählt wird. Der ausgewählte Flüssigkeitskühler dient als Referenzgerät für die Modellierung des Leistungsverhaltens der Ausgangsbasis und die Auswahl des Flüssigkeitskühler-Ersatzmodells.",
    row54_1: "Benutzerbibliothek",
    row54_2: "Eine persönliche Bibliothek mit vom Benutzer hochgeladenen oder verwalteten Flüssigkeitskühlerdaten.",
    row55_1: "Teillast",
    row55_2: "Betrieb unterhalb der vollen Nennleistung.",
    row56_1: "Amortisationszeit",
    row56_2: "Die Anzahl der Jahre, bis die kumulierten jährlichen Einsparungen den gesamten Investitionsausgaben (CAPEX) entsprechen.",
    row57_1: "Hochtarifzeit",
    row57_2:
      "Monatlicher Durchschnitt der täglichen Höchsttemperaturen. Er repräsentiert den heißesten Tagesabschnitt und wird zur Gewichtung der Zuordnung zu tagsüber liegenden Hochtarifzeiten verwendet.",
    row58_1: "Hoch- / Niedertarifzeiten im Tarif",
    row58_2: "Zeitabhängige Strompreiszeiträume, in denen während der Hochtarifzeiten höhere und während der Niedertarifzeiten niedrigere Tarife gelten.",
    row59_1: "Anlagenleitsystem",
    row59_2:
      "Die Automatisierungs- und Regelungsinfrastruktur einschließlich Sensoren, Reglern und Integration in die Gebäudeleittechnik (BMS), die zur Optimierung des Betriebs der vorgeschlagenen Kältezentrale dient; sie wird als Position der Investitionsausgaben (CAPEX) berücksichtigt.",
    row60_1: "PLR",
    row60_2: "Teillastverhältnis.",
    row61_1: "Primärsystem",
    row61_2: "Eine Kaltwasserverrohrung, bei der ein einzelner Pumpensatz das Wasser sowohl durch die Flüssigkeitskühler als auch durch den Gebäudeverteilkreislauf fördert.",
    row62_1: "Primär-/Sekundärsystem",
    row62_2:
      "Eine Kaltwasserverrohrung mit getrennten Pumpensätzen: Primärpumpen versorgen die Flüssigkeitskühler, während Sekundärpumpen den Gebäudeverteilkreislauf versorgen und so eine unabhängige Volumenstromregelung ermöglichen.",
    row63_1: "Prozesskühlung",
    row63_2:
      "Kühlung für industrielle oder produktionstechnische Prozesse, beispielsweise Rechenzentren oder die pharmazeutische Produktion; in iECM erfordert sie die auf Energieverbrauch basierende Methode zur Ermittlung der Ausgangsbasis.",
    row64_1: "Vorgeschlagene Lösung",
    row64_2: "Die empfohlene neue Lösung, die im Vergleich zur Ausgangsbasis bewertet wird.",
    row65_1: "Flüssigkeitskühler-Ersatzmodell",
    row65_2: "Ein aus der e-CAT-Bibliothek ausgewähltes Carrier-Flüssigkeitskühlermodell, das den am Standort betriebenen Flüssigkeitskühler zur Leistungsschätzung und Kalibrierung abbildet.",
    row66_1: "Neu konfigurieren",
    row66_2:
      "Eine iECM-Funktion, mit der Benutzer den automatischen Algorithmus zur Flüssigkeitskühlerauswahl manuell übersteuern und bestimmte Flüssigkeitskühler bestimmten Betriebszeiträumen innerhalb einer Modernisierungslösung zuordnen können.",
    row67_1: "Referenz-Flüssigkeitskühler",
    row67_2:
      "Der als Leistungsreferenz für ein bestimmtes Betriebsmuster der Ausgangsbasis ausgewählte Flüssigkeitskühler; sämtliche Berechnungen zu Leistungsaufnahme, Kühllast und Degradation dieser Ausgangsbasis werden aus seinen technischen Daten abgeleitet.",
    row68_1: "Modernisierung",
    row68_2: "Die Optimierung oder der Austausch vorhandener Geräte einer Kältezentrale durch neuere, effizientere Technik, um Energieverbrauch und Betriebskosten zu senken.",
    row69_1: "ROI",
    row69_2: "Kapitalrendite; jährliche Einsparungen als Prozentsatz der Gesamtinvestition.",
    row70_1: "RT",
    row70_2: "Kältetonne; eine Einheit der Kälteleistung.",
    row71_1: "RTh",
    row71_2: "Kältetonnenstunde; eine Einheit der Kälteenergie.",
    row72_1: "Tarifsatz",
    row72_2: "Der vom Energieversorger berechnete Strompreis je kWh; er wird bei der Konfiguration der Ausgangsbasis getrennt für Hoch- und Niedertarifzeiten eingegeben.",
    row73_1: "Frequenzumrichter (VFD)",
    row73_2: "Frequenzumrichter; ein Gerät, das die Motordrehzahl an die Last anpasst.",
    row74_1: "Wassergekühlter Flüssigkeitskühler",
    row74_2:
      "Ein Flüssigkeitskühler, der Wärme über einen mit Kühltürmen verbundenen Verflüssigerkühlwasserkreislauf abführt und bei Volllast typischerweise effizienter als ein luftgekühlter Flüssigkeitskühler ist.",
    row75_1: "WC",
    row75_2: "Wassergekühlt."
  }
}



// WEBPACK FOOTER //
// ./src/locale/outputFile/de.js